import { makeStyles } from '@material-ui/core'
import React, { ReactElement, useState } from 'react'
import Header from '@Components/Layout/Header'
import { styles } from '@Components/Layout/layout.style'
import Sidebar from '@Components/Layout/Sidebar'
import { AuthContextType, useAuth } from '@Hooks/useAuth'
import Login from '../pages/Login'
import Routes from '../routes/Routes'
import clsx from 'clsx'
import { useGlobal } from '@Hooks/useGlobal'
import G2FA from './G2FA'
import LoggedOut from './ThairathAuth/LoggedOut'
import ThairathAuthComplete from './ThairathAuth/Complete'
import NoPermission from './ThairathAuth/NoPermission'

const useStyles = makeStyles(styles)
export default function Pages(): ReactElement {
  const classes = useStyles()
  const { openMenu } = useGlobal()
  const { user } = useAuth() as AuthContextType
  const [isG2FA, setIsG2FA] = useState(false)
  const [username, setUsername] = useState('')

  // routes that must stay reachable without a session and never auto-redirect
  if (!user && window.location.pathname === '/logged-out') return <LoggedOut />
  if (!user && window.location.pathname === '/auth/thairath/complete')
    return <ThairathAuthComplete />
  // a user created on first thairath login has no roles until an admin grants some
  if (user && !user.roles?.length) return <NoPermission />

  return (
    <>
      {!user ? (
        <>
        {!isG2FA ? (
          <Login
            onSuccess={(username) => {
              setUsername(username)
              setIsG2FA(true)
            }}
          />
        ) : (
          <G2FA _username={username} onEnd={() => setIsG2FA(false)} />
        )}
      </>

        
      ) : (
        <div className={classes.root}>
          <div
            className={clsx(classes.container, {
              [classes.container_shift]: openMenu,
            })}
          >
            <Header />
            <main className={clsx(classes.main)}>
              <Routes />
            </main>
          </div>
          <Sidebar />
        </div>
      )}
    </>
  )
}
